import { render, staticRenderFns } from "./OrgAction.vue?vue&type=template&id=330766f4"
import script from "./OrgAction.vue?vue&type=script&lang=js"
export * from "./OrgAction.vue?vue&type=script&lang=js"
import style0 from "./OrgAction.vue?vue&type=style&index=0&id=330766f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports